import {ColumnConfig} from '@common/datatable/column-config';
import {CustomPost} from '@app/blog/post/custom-post';
import {Trans} from '@common/i18n/trans';
import {Link} from 'react-router-dom';
import {LinkStyle} from '@common/ui/buttons/external-link';
import {NameWithAvatar} from '@common/datatable/column-templates/name-with-avatar';
import {FormattedDate} from '@common/i18n/formatted-date';
import React from 'react';
import {IconButton} from '@common/ui/buttons/icon-button';
import {EditIcon} from '@common/icons/material/Edit';
import {ContentCopyIcon} from '@common/icons/material/ContentCopy';
interface PostDatatableColumnsProps {
  duplicatePost: (postId: number) => void;
}
export const PostDatatableColumns = ({ duplicatePost }: PostDatatableColumnsProps): ColumnConfig<CustomPost & { id: string | number }>[] => [  
  {
    key: 'title',
    allowsSorting: true,
    width: 'flex-2 min-w-200',
    visibleInMode: 'all',
    header: () => <Trans message="Title" />,
    body: page => (
      <Link target="_blank" to={`${page.url}${page.slug}`} className={LinkStyle}>
        {page.title}
      </Link>
    ),
  },     
  {
    key: 'status',
    allowsSorting: true,
    width: 'w-200',
    header: () => <Trans message="Status" />,
    body: page => <Trans message={page?.status || ""} />,
  },
  {
    key: 'updated_at',
    allowsSorting: true,
    width: 'w-100',
    header: () => <Trans message="Last updated" />,
    body: page => <FormattedDate date={page.updated_at} />,
  },
  {
    key: 'actions',
    header: () => <Trans message="Actions" />,
    hideHeader: true,
    align: 'end',
    width: 'w-84 flex-shrink-0',
    visibleInMode: 'all',
    body: page => (
      <>
      <IconButton
        size="md"
        className="text-muted"
        elementType={Link}
        to={`${page.id}/edit`}
      >
        <EditIcon />
      </IconButton>
      <IconButton className="text-muted" onClick={() => duplicatePost(Number(page.id))}><ContentCopyIcon /></IconButton>
      </>
    ),
  },
];
